import { apiService } from "./api";
import { Product } from "../types";

// Arrange Shop — the website's default ("Recommended") product order and
// the pins / push-downs staff put on it. See api/app/services/merchandising.py.

export interface ArrangedProduct {
    product: Product;
    /** Units sold in the ranking window (sales_days). */
    units_sold: number;
    is_new: boolean;
    has_photo: boolean;
    in_stock: boolean;
    score: number;
    pin_position: number | null;
}

export interface ArrangePreview {
    sales_days: number;
    new_days: number;
    max_pins: number;
    pins: ArrangedProduct[];
    automatic: ArrangedProduct[];
    automatic_total: number;
    pushed_down: ArrangedProduct[];
}

class MerchandisingService {
    /** categoryId null = the whole shop. */
    async getPreview(categoryId: string | null): Promise<ArrangePreview> {
        const qs = categoryId ? `?category_id=${encodeURIComponent(categoryId)}` : "";
        return apiService.get<ArrangePreview>(`/merchandising/preview${qs}`);
    }

    async savePins(categoryId: string | null, productIds: string[]): Promise<string[]> {
        return apiService.put<string[]>("/merchandising/pins", {
            category_id: categoryId,
            product_ids: productIds,
        });
    }

    async setPushedDown(productIds: string[], pushedDown: boolean): Promise<void> {
        if (productIds.length === 0) return;
        await apiService.put("/merchandising/pushed-down", {
            product_ids: productIds,
            pushed_down: pushedDown,
        });
    }
}

export const merchandisingService = new MerchandisingService();
